'use client'

import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

import { getCookie } from '@/helpers/cookie'
import { UpdateSelectedClient } from '@/server/controllers/users/update-client-selected'

export type SelectedClient = {
  id: number
  name: string
}

interface SelectedClientContextType {
  selectedClient: SelectedClient | null
  updateSelectedClient: (selectedClient: SelectedClient) => void
}

const SelectedClientContext = createContext<
  SelectedClientContextType | undefined
>(undefined)

export const SelectedClientProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedClient, setSelectedClient] = useState<SelectedClient | null>(
    null,
  )

  const updateSelectedClient = async (selectedClient: SelectedClient) => {
    await UpdateSelectedClient(selectedClient)

    setSelectedClient(selectedClient)
  }

  useEffect(() => {
    const clientSelected = getCookie('clientSelected')
    if (clientSelected) {
      const userData: SelectedClient = JSON.parse(clientSelected)
      setSelectedClient(userData)
    }
  }, [])

  return (
    <SelectedClientContext.Provider
      value={{ selectedClient, updateSelectedClient }}
    >
      {children}
    </SelectedClientContext.Provider>
  )
}

export const useSelectedClient = () => {
  const context = useContext(SelectedClientContext)
  if (!context) {
    throw new Error(
      'useSelectedClient must be used within a SelectedClientProvider',
    )
  }

  return context
}
